export function isVowel(string) {
  if (!string) {
    return false;
  }
  const x = Array.from(string.normalize('NFD').replace(/[\u0300-\u036f]/g, ''))[0];
  return 'aeiouAEIOU'.indexOf(x) !== -1;
}
